import { createContext } from "react";
import { UserInfo } from "@/interfaces/Resources";

const UserContext = createContext({} as UserInfo);

export default UserContext;
